import { useState, useEffect } from "react";
import { saveItemGroup2, getAllItemGroups, getItemGroups1ByItemGroupCode } from "../Api/ItemGroup2";
import {  Accordion,
  AccordionItem,
  AccordionBody, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const ItemGroup2 = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [itemGroups, setItemGroups] = useState([]);
  const [itemGroups1, setItemGroups1] = useState([]);
  const [itemGroup2Data, setItemGroup2Data] = useState({
    code: "",
    description: "",
    itemGroupCode: "",
    itemGroup1: ""
  });

  // Fetch item groups for dropdown
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const groups = await getAllItemGroups();
        setItemGroups(groups);
      } catch (error) {
        toast.error("Failed to load item groups");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Fetch item groups 1 when item group code changes
  useEffect(() => {
    const fetchItemGroups1 = async () => {
      if (itemGroup2Data.itemGroupCode) {
        setLoading(true);
        try {
          const groups1 = await getItemGroups1ByItemGroupCode(itemGroup2Data.itemGroupCode);
          setItemGroups1(groups1);
          // Reset itemGroup1 when itemGroupCode changes
          setItemGroup2Data(prev => ({ ...prev, itemGroup1: "" }));
        } catch (error) {
          toast.error("Failed to load item groups 1");
          setItemGroups1([]);
        } finally {
          setLoading(false);
        }
      } else {
        setItemGroups1([]);
      }
    };

    fetchItemGroups1();
  }, [itemGroup2Data.itemGroupCode]);

  const handleChange = (e) => {
    setItemGroup2Data({ ...itemGroup2Data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await saveItemGroup2(itemGroup2Data);
      toast.success("🦄 Item Group 2 Added Successfully");
      setItemGroup2Data({
        code: "",
        description: "",
        itemGroupCode: "",
        itemGroup1: ""
      });
      navigate("/viewItemGroup2");
    } catch (error) {
      toast.error(error.message || "🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container item-group2-fields">
          <h2 className="fields-title">Item Group 2</h2>

          <Form onSubmit={handleSubmit} className="fields-form">

           <Accordion
            defaultActiveKey="0"
            className="gl-master-accordion"
          >
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Code <span className="text-red">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="code"
                    value={itemGroup2Data.code}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Description <span className="text-red">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="description"
                    value={itemGroup2Data.description}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Item Group <span className="text-red">*</span>
                  </Form.Label>
                  <Form.Select
                    name="itemGroupCode"
                    value={itemGroup2Data.itemGroupCode}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Item Group</option>
                    {itemGroups.map((group) => (
                      <option key={group.code} value={group.code}>
                        {group.code} - {group.description}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Item Group 1 <span className="text-red">*</span>
                  </Form.Label>
                  <Form.Select
                    name="itemGroup1"
                    value={itemGroup2Data.itemGroup1}
                    onChange={handleChange}
                    required
                    disabled={!itemGroup2Data.itemGroupCode}
                  >
                    <option value="">Select Item Group 1</option>
                    {itemGroups1.map((group) => (
                      <option key={group.code} value={group.code}>
                        {group.code} - {group.description}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
</AccordionBody>
            </AccordionItem>
          </Accordion>
            <div className="fields-btn-container" style={{ marginTop: 16 }}>
              <Button variant="primary" type="submit" className="fields-submit">
                Save Item Group 2
              </Button>
            </div>
          </Form>
      </div>
      
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ItemGroup2;